export * from './CompetitionCard';
export {CoinsIcon2 as CoinsIcon} from './CoinsIcon';
